import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
        Я хочу быть железным плугом,<br/>
        Я хочу вгрызаться с размаху<br/>
        В вязкость тяжкую чёрной земли.
      </p>

      <p class="poem-block mb-3">
        Я хочу быть моторной лодкой,<br/>
        Я хочу взрезать, не жалея<br/>
        Гладкой речки блестящую твердь.
      </p>

      <p class="poem-block mb-3">
        А если б я был человеком,<br/>
        И в руке у меня бы нож был,<br/>
        О, с каким наслажденьем я бы<br/>
        Нож вонзил в человечью плоть!
      </p>

      <p class="poem-block mb-3">
        Но нет ни ножа, ни кинжала,<br/>
        И своё я вонзаю жало,<br/>
        Свой пылающий яростно орган<br/>
        Меж пылающих женских ног!
      </p>
    </div>
    `
  )
}

const itemName = {
  rus: 'Революционер'
}

const item = {
  itemlink: getLink(itemName.rus),
  rus:{
    itemName: itemName.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}


export default item;